import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice, Pager } from "../../lib/ui";

/* Every payment record – port of paymentAjax.php (API: /api/payments/all). Sortable, searchable, 10 per page. */

const COLS = [["payment_id", "ID", 1], ["payment_date", "Date"], ["payment_amount", "Amount", 1], ["payment_method", "Method"], ["status", "Status"], ["invoice_id", "Invoice", 1],
  ["po_id", "PO", 1], ["client_id", "Client", 1], ["service_id", "Service", 1], ["payment_type", "Type"], ["payment_class", "Class"]];

export default function PaymentsAll() {
  const api = useApi();
  const [q, setQ] = useState({ page: 1, sort: "payment_id", order: "asc", search: "" });
  const [term, setTerm] = useState("");
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (p) => { try { setD(await api.get("/api/payments/all", p)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.search === term ? s : { ...s, search: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  const sortBy = (k) => setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "asc" ? "desc" : "asc", page: 1 }));
  return (
    <main className="pg" style={{ maxWidth: "100rem" }}>
      <PageHeader slug="paymentAjax" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <div className="toolbar"><div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" />
          <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search method, status, class or details" aria-label="Search payments" /></div></div>
          {d && <span style={{ alignSelf: "center", fontSize: ".8rem", color: "var(--muted)" }}>{d.total} payments</span>}</div>
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr>{COLS.map(([k, l, num]) => <th key={k} className={`sortable ${num ? "num" : ""}`} onClick={() => sortBy(k)}>{l} {q.sort === k && <i className={`fas ${q.order === "asc" ? "fa-sort-up" : "fa-sort-down"}`} />}</th>)}<th>Details</th></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.payment_id}>
            <td className="num mono">{r.payment_id}</td><td>{String(r.payment_date || "").slice(0, 10)}</td><td className="num mono">{n2(r.payment_amount)}</td><td>{r.payment_method}</td>
            <td><span className="pill-tag">{r.status || "–"}</span></td><td className="num mono">{r.invoice_id ?? ""}</td><td className="num mono">{r.po_id ?? ""}</td>
            <td className="num mono">{r.client_id ?? ""}</td><td className="num mono">{r.service_id ?? ""}</td><td>{r.payment_type ?? ""}</td><td>{r.payment_class}</td>
            <td style={{ color: "var(--muted)", maxWidth: "16rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={r.payment_details || ""}>{r.payment_details}</td></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty">No payment records found.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
    </main>
  );
}
